import { useQueryHook } from "@/hooks"
import { readCountryList, readDownloadList } from "@/app/api/util"

export const useCountryListQuery = () => {
  return useQueryHook({ queryKey: ["countryList"], queryFn: readCountryList })
}

export const useDownloadListQuery = () => {
  return useQueryHook({ queryKey: ["downloadList"], queryFn: readDownloadList })
}
